import React, { useState, useContext, useEffect } from "react";
import { useAuth } from "../../hooks/customers/AuthProvider";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as Config from "../../config/config";
import { LoaderContext } from "../utils/Contexts";
import API from "../../api/client";
import * as ENDPOINTS from "../../api/endpoints";
import OrderItems from "./OrderItems";
import Search from "./Search";
import Title from "./Title";

function PendingOrders() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const auth = useAuth();
  const customer = auth?.customer;
  // State for search input
  const [searchTerm, setSearchTerm] = useState("");
  const { isLoader, setLoader } = useContext(LoaderContext);
  const [orders, setOrders] = useState([]);
  const [reload, setReload] = useState(false);
  const [ordersLoaded, setOrdersLoaded] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const handleInputChange = (e) => {
    const keayword = e.target.value;
    setSearchTerm(keayword);
  };

  const getOrders = async (pageNum = 1, append = false) => {
    const customerId = auth.customer._id;
    setLoader(true);
    let url = `${ENDPOINTS.DISTRICT_MANAGER_ORDERS}/${customerId}?sort=-post_date&limit=${Config.ORDERS_LIMIT}&page=${pageNum}`;
    if (searchTerm) {
      url = `${url}&reference_no=${searchTerm}`;
    }
    const response = await API.getWithToken(url);
    if (response.statusText === "OK") {
      //setOrders(response?.data?.data.orders);
      const newOrders = response?.data?.data?.orders || [];
      setOrders(prev =>
        append ? [...prev, ...newOrders] : newOrders
      );
      setHasMore(newOrders.length === Config.ORDERS_LIMIT);
    }
    setLoader(false);
    setOrdersLoaded(true);
  };

  useEffect(() => {
    const delayInputTimeoutId = setTimeout(() => {
      getOrders(1, false);
    }, 1000);
    return () => clearTimeout(delayInputTimeoutId);
  }, [searchTerm]);

  useEffect(() => {
    if (reload) {
      getOrders(1, false);
    }
  }, [reload]);

  // useEffect(() => {
  //   if (customer?.role != Config.DISTRICT_MANAGER_ROLE) {
  //     navigate(Config.REDIRECT_PAGE_AFTER_LOGIN);
  //   } else {
  //     getOrders();
  //   }
  // }, []);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 100 && hasMore && !isLoader) {
      const nextPage = page + 1;
      setPage(nextPage);
      getOrders(nextPage, true); // fetch next page, append results
    }
  };

  return (
    <div className="pending-orders favbg">
      <div className="innerwrapper">
        <div className="search_fav customscroll" onScroll={handleScroll}>
          <Search
            handleInputChange={handleInputChange}
            searchTerm={searchTerm}
          />
          <Title />
          {orders.length > 0 && <OrderItems orders={orders} setReload={setReload} />}
          {!isLoader && orders.length === 0 && ordersLoaded && (
            <div className="empty-search-result-wrapper">
              <div className="empty-search-result">
                {t("no_result_found_txt")}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PendingOrders;
